import { MapperBase } from "@utilities/mapper-base";
import { ReportResponseResource } from "@models/resource/report-response.resource";
import { CustodianDetail, CustodianState } from "@models/ui/case-analytics-state/custodian-state.model";

export class ReportResponseResourceToCustodianStateMapper extends MapperBase<ReportResponseResource, CustodianState> {
	map(source: ReportResponseResource): CustodianState {
		const dest = new CustodianState();
		let sum = 0;
		dest.custodians = source?.data.map((item) => {
			const custodian = new CustodianDetail();
			custodian.docCount = Number(item?.total);
			custodian.name = item?.pivot;
			sum += custodian.docCount;
			return custodian;
		});
		dest.custodians = dest.custodians.filter((x) => x.name !== 'Total');
		dest.totalDocCount = sum;
		dest.caseCustodianCount = dest.custodians.length;
		return dest;
	}
}
